import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { bandOf } from '../risk-register.util';

interface Cell { probability: number; impact: number; count: number; band: string; selected: boolean }

/** 5×5 count grid: rows = impact 5→1, columns = probability 1→5; click toggles a cell filter. */
@Component({
  selector: 'app-risk-heat-map',
  templateUrl: './risk-heat-map.component.html',
  styleUrls: ['./risk-heat-map.component.scss'],
  standalone: false,
})
export class RiskHeatMapComponent implements OnChanges {
  @Input() cells: { probability: number; impact: number; count: number }[] = [];
  @Input() selected: { probability: number; impact: number } | null = null;
  @Output() cellSelected = new EventEmitter<{ probability: number; impact: number } | null>();

  rows: Cell[][] = [];
  readonly probabilities = [1, 2, 3, 4, 5];

  ngOnChanges(): void {
    const counts = new Map((this.cells || []).map(c => [`${c.probability},${c.impact}`, c.count]));
    this.rows = [5, 4, 3, 2, 1].map(impact => this.probabilities.map(probability => ({
      probability, impact,
      count: counts.get(`${probability},${impact}`) || 0,
      band: bandOf(probability * impact),
      selected: !!this.selected && this.selected.probability === probability && this.selected.impact === impact,
    })));
  }

  toggle(cell: Cell): void {
    this.cellSelected.emit(cell.selected ? null : { probability: cell.probability, impact: cell.impact });
  }
}
